import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 text-left" }
const _hoisted_3 = { class: "is-web mt-4" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", { class: "thead-light" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "message"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "created_at")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterComponent = _resolveComponent("FilterComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FilterComponent, {
        onFilter: _ctx.getFilter,
        class: "is-mobile"
      }, null, 8, ["onFilter"]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.searchMood)
          ? (_openBlock(), _createBlock(_component_FilterComponent, {
              key: 0,
              onFilter: _ctx.getFilter,
              class: "mt--4"
            }, null, 8, ["onFilter"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_DataTable, {
          class: "table align-items-center table-flush",
          options: _ctx.options,
          onInstance: _ctx.dtInstance,
          id: "alarm-list"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["options", "onInstance"])
      ])
    ])
  ]))
}